/** angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Moldes */
import { DsFormsExcelResult } from '../classes/forms-excel/ds-forms-excel-result.class';
import { DsFormsExcelSheetImportResult } from '../classes/forms-excel/ds-forms-excel-sheet-import-result.class';
/** Interfaces */
import { DsFormsExcelSheetImportResultInterface } from '../interfaces/forms-excel/ds-forms-excel-sheet-import-result.interface';

/**
 * Service to import one excel worksheet.
 */
@Injectable({
  providedIn: 'root',
})
export class DsFormExcelSheetImportService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Returns the list of fields and the potential errors.
   *
   * @param excelTabs Object containing one or several excel worksheets.
   * @returns Observable<DsFormsExcelResult>
   */
  public getSheetFields(excelTabs: DsFormsExcelResult): Observable<DsFormsExcelSheetImportResult> {
    this.path = `/v1/dsform/excelconvertion/fields`;
    return this.postModel<DsFormsExcelSheetImportResult>({ body: excelTabs });
  }

  /**
   * Create DsFormsExcelSheetImportResult instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsFormsExcelSheetImportResult` instance.
   */
  public createNewInstance(jsonObject: DsFormsExcelSheetImportResultInterface): DsFormsExcelSheetImportResult {
    return new DsFormsExcelSheetImportResult(jsonObject);
  }
}
